import axios from 'axios'
import $store from '../store/index'
import * as common from './common'
import * as constant from './constant'
import {
  isHaveAuthAccount,
  clearVhPNullRecord
} from './util'

const SESSION_VERIFIED_KEY = 'vh_p_null_identity_verified'

export function getWechatIdentityKey ({ unionid, openid } = {}) {
  return (unionid || openid || '').trim()
}

export function getCachedWechatIdentity () {
  const auth = $store.state.wxZfbAuthInfo.wxZfbAuthInfo
  const unionid = (auth && auth.unionid) || ($store.state.unionID && $store.state.unionID.unionID) || ''
  const openid = (auth && auth.openid) || ($store.state.openID && $store.state.openID.openID) || ''
  const key = getWechatIdentityKey({ unionid, openid })
  return { unionid, openid, key }
}

export async function fetchGzhOpenidByCode (sid, code) {
  const { data } = await axios({
    url: common.cloudPayUrl + '/pub/pay.bill.park_plate.get_gzh_openid',
    method: 'POST',
    data: {
      sid,
      code
    },
    header: {
      'content-type': 'application/json'
    }
  })
  if (data && data.code === 10000) {
    return data
  }
  throw new Error((data && data.msg) || '获取微信用户信息失败')
}

export function applyWechatIdentity (data) {
  $store.commit(constant.keyWxZfbAuthInfoVuex, data)
  if (data.openid) {
    $store.commit(constant.keyOpenIDVuex, data.openid)
  }
  if (data.unionid) {
    $store.commit(constant.keyUnionIDVuex, data.unionid)
  }
}

export function clearLocalPhone () {
  $store.commit(constant.keyPhoneVuex, null)
}

export async function syncPhoneFromServer (sid, openid) {
  if (!sid || !openid) {
    clearLocalPhone()
    return
  }
  try {
    const { UserService } = await import('./userService')
    const data = await UserService.getUserInfo(sid, openid)
    if (data.code === 10000 && data.info && data.info.phone_number) {
      $store.commit(constant.keyPhoneVuex, data.info.phone_number)
    } else {
      clearLocalPhone()
    }
  } catch (e) {
    console.error('[wechatIdentitySync] syncPhoneFromServer', e)
    clearLocalPhone()
  }
}

export function buildVhPNullInReturnUrl ({ sid, channelPath, direction }) {
  let url = window.location.origin + '/#/vh_p_n_in'
  const params = []
  if (sid) {
    params.push('sid=' + encodeURIComponent(sid))
  }
  if (channelPath !== undefined && channelPath !== null && channelPath !== '') {
    params.push('channel_path=' + encodeURIComponent(channelPath))
  }
  if (direction !== undefined && direction !== null && direction !== '') {
    params.push('direction=' + encodeURIComponent(String(direction)))
  }
  if (params.length) {
    url += '?' + params.join('&')
  }
  return url
}

export async function redirectToSilentWechatOAuth (sid, returnUrl) {
  const { getGzhAppIdWx } = await import('./paycloudService')
  const appid = await getGzhAppIdWx(sid)
  if (!appid) {
    throw new Error('获取appid失败')
  }
  const target = new URL(returnUrl)
  window.location.href = common.getCodeObtainUrl(target, appid, true)
}

/**
 * 无牌车入场：有缓存时 snsapi_base 静默校验微信身份；换号则覆盖缓存并清无牌车记录。
 * 无缓存时不静默跳转，由页面弹授权 UI。
 * @returns {{ redirecting: boolean, noCache?: boolean, identityChanged?: boolean, error?: string }}
 */
export async function syncWechatIdentityForVhPNull ({ sid, channelPath, direction, code }) {
  if (common.getUserAgent() !== 'wx') {
    return { redirecting: false }
  }

  if (!sid) {
    return { redirecting: false, error: '缺少 sid' }
  }

  const cached = getCachedWechatIdentity()
  const hasCache = isHaveAuthAccount() && !!cached.key
  const returnUrl = buildVhPNullInReturnUrl({ sid, channelPath, direction })

  if (!hasCache && !code) {
    return { redirecting: false, noCache: true }
  }

  if (code) {
    try {
      const fresh = await fetchGzhOpenidByCode(sid, code)
      const freshKey = getWechatIdentityKey(fresh)
      if (!freshKey) {
        return { redirecting: false, error: '未获取到用户标识' }
      }

      const identityChanged = !!(cached.key && cached.key !== freshKey)
      if (identityChanged) {
        clearVhPNullRecord()
        clearLocalPhone()
      }

      applyWechatIdentity(fresh)
      await syncPhoneFromServer(sid, fresh.openid)
      sessionStorage.setItem(SESSION_VERIFIED_KEY, freshKey)

      return { redirecting: false, identityChanged }
    } catch (e) {
      console.error('[wechatIdentitySync]', e)
      sessionStorage.removeItem(SESSION_VERIFIED_KEY)
      return { redirecting: false, error: e.message || '微信身份校验失败' }
    }
  }

  if (hasCache) {
    const verified = sessionStorage.getItem(SESSION_VERIFIED_KEY)
    if (verified && verified === cached.key) {
      return { redirecting: false }
    }
    await redirectToSilentWechatOAuth(sid, returnUrl)
    return { redirecting: true }
  }

  return { redirecting: false }
}
